<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'

withDefaults(
  defineProps<{
    isActive?: boolean
    isGray?: boolean
    title: string
  }>(),
  {
    isActive: false,
    isGray: false
  }
)
</script>

<template>
  <BasicButton
    class="
      duration-3 !h-8 !rounded-2xl !border !border-solid !px-3 !text-sm !font-normal transition-all
      hover:!border-main-green hover:!text-main-green
      md:!h-11 md:!text-base
    "
    :class="
      isActive
        ? `!border-main-green ${isGray ? '!bg-main-very-light-gray' : '!bg-white'} !text-main-green`
        : `!border-transparent ${isGray ? '!bg-main-gray-low' : '!bg-white'} !text-main-silver`
    "
    :color="isActive ? 'green' : 'light-gray'"
    is-small
    :title="title"
  />
</template>
